import {SEARCH_PROP_TYPES} from "../../enums/e-search";
import {ISearchParam} from "../../definitions";
export class SearchParams {
  private usedProperties: any;
  private _search: ISearchParam[];


  constructor() {
    this.usedProperties = {};
    this._search = [];
  }


  addNumberParam(property: string,
                 value: number = null,
                 label?: string): SearchParams {
    this.addParam(property, SEARCH_PROP_TYPES.NUMBER, value);
    return this;
  }


  addStringParam(property: string,
                 value: string = null,
                 label?: string): SearchParams {
    this.addParam(property, SEARCH_PROP_TYPES.STRING, value);
    return this;
  }


  addObjectIdParam(): SearchParams {
    this.addParam("_id", SEARCH_PROP_TYPES.OBJECT_ID, "", "По ObjectID");
    return this;
  }


  addParam(property: string,
           type: string,
           value: any,
           label?: string): SearchParams {
    if (this.usedProperties[property]) {
      throw new Error(`Property ${property} already have been used!`);
    }

    let entry = {property, type, value};
    if (type == SEARCH_PROP_TYPES.NUMBER_GTE)
    {
      entry["label"] = label || `${property} >=`;
    }
    else if (type == SEARCH_PROP_TYPES.NUMBER_LTE)
    {
      entry["label"] = label || `${property} <=`;
    }
    else if (type == SEARCH_PROP_TYPES.STRING_MULTI)
    {
      entry["label"] = label || `По множеству ${property} (разделитель \",\")`;
    }
    else if (type == SEARCH_PROP_TYPES.STRING)
    {
      entry["label"] = label || `По ${property} (частично)`;
    }
    else
    {
      entry["label"] = label || `По ${property}`;
    }



    this._search.push(entry);
    return this;
  }


  get json(): ISearchParam[] {
    return this._search;
  }


  /** @deprecated use json */
  get search(): ISearchParam[] {
    return this._search;
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/helpers/params/search-params.ts